import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import reducer from '../reducer';
import { isDev } from "../utils/index";
import { connect } from 'react-redux';



const middleware = [thunk];
const reduxDevtools = window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f

 const store = createStore(
    reducer, (
        isDev() ?
        compose(applyMiddleware(...middleware), reduxDevtools) :
        applyMiddleware(...middleware)
    )
);


export const connectStore = (maActionToProps = {}) => {
    return (Component) => {
      if (!Component) return;
      const _mapStateToProps = (state) => state;
      const _maActionToProps = {
        dispatch: (dispatch) => dispatch,
        ...maActionToProps,
      };
      return connect(_mapStateToProps, _maActionToProps, null, {forwardRef: true})(Component);
    };
  };


export default store


// WEBPACK FOOTER //
// ./src/store/index.js